var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconChart(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 34,
    viewBox: "0 0 38 34",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.125 2.375C26.125 1.74511 26.3752 1.14102 26.8206 0.695621C27.266 0.250222 27.8701 0 28.5 0H33.25C33.8799 0 34.484 0.250222 34.9294 0.695621C35.3748 1.14102 35.625 1.74511 35.625 2.375V30.875H36.8125C37.1274 30.875 37.4295 31.0001 37.6522 31.2228C37.8749 31.4455 38 31.7476 38 32.0625C38 32.3774 37.8749 32.6795 37.6522 32.9022C37.4295 33.1249 37.1274 33.25 36.8125 33.25H1.1875C0.872555 33.25 0.57051 33.1249 0.347811 32.9022C0.125111 32.6795 0 32.3774 0 32.0625C0 31.7476 0.125111 31.4455 0.347811 31.2228C0.57051 31.0001 0.872555 30.875 1.1875 30.875H2.375V23.75C2.375 23.1201 2.62522 22.516 3.07062 22.0706C3.51602 21.6252 4.12011 21.375 4.75 21.375H9.5C10.1299 21.375 10.734 21.6252 11.1794 22.0706C11.6248 22.516 11.875 23.1201 11.875 23.75V30.875H14.25V14.25C14.25 13.6201 14.5002 13.016 14.9456 12.5706C15.391 12.1252 15.9951 11.875 16.625 11.875H21.375C22.0049 11.875 22.609 12.1252 23.0544 12.5706C23.4998 13.016 23.75 13.6201 23.75 14.25V30.875H26.125V2.375Z",
    fill: "#3877D6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconChart);
export default __webpack_public_path__ + "static/media/icon-chart.e74f8c037225ab3a7c62c8d4bf78cfa1.svg";
export { ForwardRef as ReactComponent };